import React, { Component, createRef } from 'react';
import { Progress, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { progressEvent } from '../../services/utility/EventBus';
import './index.css';

class SpinProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percent: 0,
      message: "",
      type: props.type || 'line',
      auto: false,
      maxAutoPercent: 99,
      theme: props.theme || 'dark',
      id: props.id
    }
    this.svgRef = createRef();
  }


  componentDidMount() {
    this._mounted = true;
    progressEvent.on(this.state.id, this.handleExternalUpdate);
    this.setupAuto();
  }

  componentWillUnmount() {
    this._mounted = false;
    progressEvent.off(this.state.id, this.handleExternalUpdate);
    clearInterval(this._timer);
  }

  handleExternalUpdate = ({ percent, message, type, auto, maxAutoPercent }) => {
    if (!this._mounted) return;
    this.setState(
      state => ({
        percent: Math.max(state.percent, percent || state.percent),
        message: message || state.message,
        type: type || state.type,
        auto: auto || state.auto,
        maxAutoPercent: maxAutoPercent || state.maxAutoPercent,
      }),
      () => this.setupAuto()
    );
  };

  setupAuto() {
    clearInterval(this._timer);
    if (this.state.auto) {
      this._timer = setInterval(() => {
        this.setState(state => {
          const next = Math.min(
            state.percent + Math.ceil(Math.random() * 5),
            state.maxAutoPercent
          );
          if (next >= state.maxAutoPercent) clearInterval(this._timer);
          return { percent: next };
        });
      }, Math.ceil(Math.random() * 2000 + 1000));
    }
  }

  progress = () => {
    const { type, propsInfo, percent, theme } = this.state;
    switch (type) {
      case 'line':
        return <Progress
          percent={percent}
          percentPosition={{ align: 'center', type: 'inner' }}
          size={[600, 20]}
          showInfo={false}
          className='aurora-spin-progress-progress'
          strokeColor={theme === 'dark' ? '#1677ff' : '#c3dcff'}
          {...propsInfo}
        />
      case 'spin':
        return <Spin spinning={true} indicator={<LoadingOutlined spin className={`aurora-spin-progress-${theme}`} />} size='large' />
      default: return;
    }
  }

  tipRender = () => {
    const { message, theme } = this.state;
    return <div className={`aurora-spin-progress-message aurora-spin-progress-${theme}`}>{message}</div>
  }

  render() {
    return <div className='aurora-spin-progress'>
      {this.progress()}
      {this.tipRender()}
    </div>
  }
}

export default SpinProgress